import BrandLogo from './BrandLogo';
import './style/index.less';

export default BrandLogo;

export * from './BrandLogo';
